var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.value)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('img',{attrs:{"src":_vm.params.value,"width":"200","height":"80"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }